import { DialogComponent } from '@theme/dialog';

export class SaferHorizonPromoModal extends DialogComponent {
  requiredRefs = ['dialog'];

  constructor() {
    super();
    this._boundHandleKlaviyoEvent = this.handleKlaviyoEvent.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    window.addEventListener('klaviyoForms', this._boundHandleKlaviyoEvent);

    if (this.refs.closeButton) {
      this.refs.closeButton.addEventListener('click', () => this.closeDialog());
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('klaviyoForms', this._boundHandleKlaviyoEvent);
  }

  handleKlaviyoEvent(event) {
    const detail = event?.detail;
    if (!detail || detail.type !== 'submit') return;

    const targetFormId = this.dataset.klaviyoFormId;
    if (targetFormId && detail.formId !== targetFormId) return;

    const scrollY = window.scrollY;
    this.showDialog();
    this.lockScrollAt(scrollY);
  }

  lockScrollAt(scrollY) {
    const restore = () => window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
    restore();
    requestAnimationFrame(restore);
    setTimeout(restore, 50);
    setTimeout(restore, 200);
  }
}

if (!customElements.get('safer-horizon-promo-modal')) {
  customElements.define('safer-horizon-promo-modal', SaferHorizonPromoModal);
}
